import { ClayTooltipProvider } from "@clayui/tooltip";
import ClayIcon from "@clayui/icon";
import { getShortText, getPersonas, getTooltipPersona } from "../../utils/util";

import { useEffect } from "react";

const LandingPageCard = ({ educationResourceItem, setCompletedCourses, t, type, userCompleteEnrollments, userInProgressEnrollments }) => {
	const description = getShortText(educationResourceItem.description || "", 150);
	const personas = getPersonas(educationResourceItem.audience || educationResourceItem.persona);
	const title = educationResourceItem.title || educationResourceItem.name;
	const tooltip = getTooltipPersona(educationResourceItem.audience || educationResourceItem.persona);

	function getCourseIdsArray(coursesData) {
		if (!Array.isArray(coursesData)) {
		  return [];
		}
		return coursesData.map(course => course.id);
	}

	useEffect(() => {
		setCompletedCourses(getCourseIdsArray(userCompleteEnrollments));
	}, [userCompleteEnrollments, setCompletedCourses]);

	return (
		<>
			<div className={`tag-${type}`}>{t(type)}</div>
			<a
				href={`/l/${type === 'course' ? educationResourceItem.firstLesson : educationResourceItem.id}`}
				className="card-link"
			>
				<div className="card-container d-flex learn-education__landing-card">
					<div className="card-content-container d-flex flex-column justify-content-between">
						<h4>{title}</h4>
						<div className="card-description">{description}</div>
						<div className="card-tags-container d-flex  learn-education">
							{type === "course" && (
								<>
									{getCourseIdsArray(userCompleteEnrollments).includes(educationResourceItem.id) && (
										<div className="align-self-start card-tag__completed card-tag__status">
											<span>{t("completed")} <ClayIcon className="ml-2" symbol="check" /></span>
										</div>
									)}

									{getCourseIdsArray(userInProgressEnrollments).includes(educationResourceItem.id) &&
										!getCourseIdsArray(userCompleteEnrollments).includes(educationResourceItem.id) && (
										<div className="align-self-start card-tag__status card-tag__inprogress">
											<span>{t("in-progress")}</span>
										</div>
									)}

								</>
							)}
							<div className="card-tags__persona__level">
								<ClayTooltipProvider>
									<div
										className="card-tag card-tag__persona"
										data-tool-tip-align="top"
										title={tooltip}
									>
										<p></p>
										<span>{personas}</span>
									</div>
								</ClayTooltipProvider>

								{educationResourceItem.level && (
									<div className={`card-tag card-tag__expertise-${educationResourceItem.level.name.toLowerCase()}`}>
										<p>{educationResourceItem.level.name}</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</a>
		</>
	);
};

export default LandingPageCard;
